import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RailCarrierLookupModel } from 'app/generated/backend/rail/api/rail-carrier-lookup-model';

@Injectable()
export class RailFclCarrierLookupHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
	): Observable<JsonResourceResponse<RailCarrierLookupModel[]>> {
		return this.http.get<JsonResourceResponse<RailCarrierLookupModel[]>>('api/v1/rail/fclCarriers/lookup').pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		RailFclCarrierLookupHandlerService
	]
})
export class RailFclCarrierLookupHandlerModule { }
